<div class="container">
  <nb-card>
    <nb-card-header>
      <h6><nb-icon icon="orbi" pack="al"></nb-icon>{{ 'pages.settings.agentAccess.title' | translate }}</h6>
    </nb-card-header>
    <nb-card-body>
      <p class="agent-access__intro">{{ 'pages.settings.agentAccess.intro' | translate }}</p>
      <p class="agent-access__intro">{{ 'pages.settings.agentAccess.signInIntro' | translate }}</p>

      @if (!enabled) {
        <p class="agent-access__hint">{{ 'pages.settings.agentAccess.disabled' | translate }}</p>
      } @else {
        <div class="agent-access__toolbar">
          <div class="agent-access__url">
            <span class="label">{{ 'pages.settings.agentAccess.url' | translate }}</span>
            <code>{{ mcpUrl }}</code>
          </div>
          @if (canSeeAll) {
            <nb-toggle [checked]="showAll" (checkedChange)="toggleAll($event)" status="primary">
              {{ 'pages.settings.agentAccess.showAll' | translate }}
            </nb-toggle>
          }
          <button nbButton status="primary" shape="round" type="button" (click)="connect()">
            <nb-icon icon="plus-outline"></nb-icon>{{ 'pages.settings.agentAccess.connect' | translate }}
          </button>
        </div>

        @if (loading) {
          <app-page-loader></app-page-loader>
        } @else if (!tokens.length) {
          <p class="agent-access__hint">{{ 'pages.settings.agentAccess.empty' | translate }}</p>
        } @else {
          <nb-list>
            @for (token of tokens; track trackToken($index, token)) {
              <nb-list-item class="agent-access__row">
                <div class="agent-access__main">
                  <span class="agent-access__name">{{ token.name }}</span>
                  <span class="agent-access__meta">
                    @if (token.kind === 'oauth') {
                      {{ 'pages.settings.agentAccess.signedIn' | translate }}
                    } @else {
                      <code>{{ token.token_prefix }}…</code>
                    }
                    @if (showAll && token.user_name) { · {{ token.user_name }} }
                    · {{ (token.can_write ? 'pages.settings.agentAccess.canWrite' : 'pages.settings.agentAccess.readOnly') | translate }}
                    · {{ 'pages.settings.agentAccess.expires' | translate: { date: (token.expires_at | date: 'dd.MM.yyyy') } }}
                    · {{ token.last_used_at
                        ? ('pages.settings.agentAccess.lastUsed' | translate: { date: (token.last_used_at | date: 'dd.MM.yyyy HH:mm') })
                        : ('pages.settings.agentAccess.neverUsed' | translate) }}
                  </span>
                </div>
                <button
                  nbButton
                  ghost
                  size="small"
                  status="danger"
                  type="button"
                  [nbSpinner]="!!revoking[token.id]"
                  [disabled]="!!revoking[token.id]"
                  [nbTooltip]="'pages.settings.agentAccess.revoke' | translate"
                  [attr.aria-label]="'pages.settings.agentAccess.revoke' | translate"
                  (click)="revoke(token)"
                >
                  <nb-icon icon="trash-2-outline"></nb-icon>
                </button>
              </nb-list-item>
            }
          </nb-list>
        }
      }
    </nb-card-body>
  </nb-card>
</div>
